import _ from "lodash";

import {
  BookingAction,
  CLEAR_BOOKING,
  UPDATE_BOOKING,
} from "../../actions/bookings/types";
import { bookingInitialState } from "./consts";
import { IBookingState } from "./types";

export default function (
  state: IBookingState = bookingInitialState,
  action: BookingAction
): IBookingState {
  switch (action.type) {
    case UPDATE_BOOKING:
      let type;
      if (action.payload.__type) {
        type = action.payload.__type;
        delete action.payload.__type;
      }

      return {
        ...state,
        booking: {
          ...state.booking,
          ...action.payload
        }
      };
    case CLEAR_BOOKING:
      return {
        ...state,
        ...bookingInitialState
      };
    default:
      return state;
  }
}
